<script>
    import Icon from '../icons/Icon.svelte';

    export let group = null;
    export let onBack = () => {};
    export let onDeleteGroup = (groupKey) => {};

    // Adiciona uma nova opção vazia ao grupo
    function addNewOption() {
        if (!group) return;
        const newId = `it_custom_${Date.now()}`;
        group.items = [
            ...(group.items || []),
            {
                id: newId,
                name: '',
                price: 0.00,
                enabled: true
            }
        ];
    }

    // Remove uma opção do grupo
    function removeOption(index) {
        if (!group || !group.items) return;
        group.items.splice(index, 1);
        group.items = [...group.items];
    }

    // Garante consistência lógica entre mínimo e máximo
    function handleMinChange(val) {
        group.min_choice = Math.max(0, parseInt(val, 10) || 0);
        if (group.min_choice > group.max_choice) {
            group.max_choice = group.min_choice;
        }
        group.required = group.min_choice > 0;
    }

    function handleMaxChange(val) {
        group.max_choice = Math.max(1, parseInt(val, 10) || 1);
        if (group.max_choice < group.min_choice) {
            group.min_choice = group.max_choice;
            group.required = group.min_choice > 0;
        }
    }

    function handleFreeChange(val) {
        group.free_choices = Math.max(0, parseInt(val, 10) || 0);
    }
</script>

{#if group}
    <div class="group-editor-flow">
        <!-- BARRA SUPERIOR DE RETORNO E AÇÕES -->
        <div class="editor-nav-bar">
            <button type="button" class="btn-back-link" on:click={onBack}>
                <Icon name="arrow-left" size={16} color="#64748B" />
                <span>Voltar para complementos</span>
            </button>

            <button type="button" class="btn-delete-group-link" on:click={() => onDeleteGroup(group.key)}>
                <Icon name="trash" size={14} color="#EF4444" />
                <span>Excluir esta categoria</span>
            </button>
        </div>

        <!-- CABEÇALHO DO GRUPO -->
        <div class="editor-header">
            <div class="title-field-wrap">
                <label for="groupNameInput" class="editor-label">Nome do Grupo de Complementos</label>
                <input
                    id="groupNameInput"
                    type="text"
                    bind:value={group.name}
                    placeholder="Ex: Ponto da Carne, Adicionais, Tipo de Molho..."
                    class="clean-group-title-input"
                />
            </div>
            <p class="editor-subtext">
                Defina como o cliente poderá escolher este complemento ao fazer o pedido.
            </p>
        </div>

        <!-- REGRAS DE ESCOLHA (GRID LIMPO) -->
        <div class="rules-card">
            <span class="rules-title">Regras de Escolha</span>
            <div class="rules-grid">
                <div class="rule-box">
                    <label for="ruleRequired">Obrigatório?</label>
                    <select
                        id="ruleRequired"
                        class="clean-select"
                        bind:value={group.required}
                        on:change={(e) => {
                            group.required = e.target.value === 'true';
                            if (group.required && group.min_choice === 0) {
                                group.min_choice = 1;
                            } else if (!group.required) {
                                group.min_choice = 0;
                            }
                        }}
                    >
                        <option value={true}>Sim (Obrigatório)</option>
                        <option value={false}>Não (Opcional)</option>
                    </select>
                </div>

                <div class="rule-box">
                    <label for="ruleMin">Mínimo</label>
                    <input
                        id="ruleMin"
                        type="number"
                        min="0"
                        max="20"
                        value={group.min_choice}
                        on:input={(e) => handleMinChange(e.target.value)}
                        class="clean-input"
                    />
                </div>

                <div class="rule-box">
                    <label for="ruleMax">Máximo</label>
                    <input
                        id="ruleMax"
                        type="number"
                        min="1"
                        max="50"
                        value={group.max_choice}
                        on:input={(e) => handleMaxChange(e.target.value)}
                        class="clean-input"
                    />
                </div>

                <div class="rule-box">
                    <label for="ruleFree">Gratuitos</label>
                    <input
                        id="ruleFree"
                        type="number"
                        min="0"
                        max="50"
                        value={group.free_choices}
                        on:input={(e) => handleFreeChange(e.target.value)}
                        class="clean-input"
                    />
                </div>
            </div>
        </div>

        <!-- LISTA DE OPÇÕES / PREÇOS -->
        <div class="options-card">
            <div class="options-header">
                <div>
                    <span class="options-title">Opções deste grupo</span>
                    <span class="options-subtitle">Nome da opção e acréscimo de valor (R$)</span>
                </div>
                <button type="button" class="btn-add-option" on:click={addNewOption}>
                    <Icon name="plus" size={14} color="#0F172A" />
                    <span>Adicionar Opção</span>
                </button>
            </div>

            <div class="options-list">
                {#if !group.items || group.items.length === 0}
                    <div class="empty-options">
                        Nenhuma opção cadastrada neste grupo. Clique em "Adicionar Opção" acima.
                    </div>
                {:else}
                    {#each group.items as item, idx}
                        <div class="option-row {!item.enabled ? 'is-disabled' : ''}">
                            <div class="col-status" title={item.enabled ? 'Opção ativa' : 'Opção pausada'}>
                                <input
                                    type="checkbox"
                                    bind:checked={item.enabled}
                                    class="option-check"
                                />
                            </div>

                            <div class="col-name">
                                <input
                                    type="text"
                                    bind:value={item.name}
                                    placeholder="Nome da opção..."
                                    class="option-name-input"
                                />
                            </div>

                            <div class="col-price">
                                <span class="currency-prefix">R$</span>
                                <input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    bind:value={item.price}
                                    class="option-price-input"
                                    placeholder="0,00"
                                />
                            </div>

                            <div class="col-actions">
                                <button
                                    type="button"
                                    class="btn-remove-option"
                                    on:click={() => removeOption(idx)}
                                    title="Remover opção"
                                >
                                    <Icon name="trash" size={14} color="#94A3B8" />
                                </button>
                            </div>
                        </div>
                    {/each}
                {/if}
            </div>
        </div>

        <!-- AÇÃO DE CONCLUSÃO DO GRUPO -->
        <div class="editor-footer">
            <button type="button" class="btn-save-group" on:click={onBack}>
                <Icon name="check" size={16} color="#FFFFFF" />
                <span>Salvar e voltar aos complementos</span>
            </button>
        </div>
    </div>
{/if}

<style>
    .group-editor-flow {
        display: flex;
        flex-direction: column;
        gap: 20px;
        max-width: 820px;
        margin: 0 auto;
        width: 100%;
    }

    /* BARRA SUPERIOR */
    .editor-nav-bar {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .btn-delete-group-link {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        background: none;
        border: none;
        color: #DC2626;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        padding: 4px 8px;
        border-radius: 6px;
        transition: background 0.15s;
    }

    .btn-delete-group-link:hover {
        background: #FEE2E2;
    }

    .btn-back-link {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        background: none;
        border: none;
        color: #475569;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        padding: 4px 0;
        transition: color 0.15s;
    }

    .btn-back-link:hover {
        color: #0F172A;
    }

    /* CABEÇALHO */
    .editor-header {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .title-field-wrap {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .editor-label {
        font-size: 12px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.6px;
        color: #64748B;
    }

    .clean-group-title-input {
        height: 48px;
        padding: 0 16px;
        background: #FFFFFF;
        border: 1px solid #CBD5E1;
        border-radius: 10px;
        font-size: 18px;
        font-weight: 700;
        color: #0F172A;
        outline: none;
        transition: all 0.15s;
    }

    .clean-group-title-input:focus {
        border-color: #FF6A00;
        box-shadow: 0 0 0 3px rgba(255, 106, 0, 0.12);
    }

    .editor-subtext {
        font-size: 13px;
        color: #64748B;
        margin: 0;
    }

    /* REGRAS */
    .rules-card {
        background: #FFFFFF;
        border: 1px solid #E2E8F0;
        border-radius: 12px;
        padding: 18px 20px;
        display: flex;
        flex-direction: column;
        gap: 12px;
        box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
    }

    .rules-title {
        font-size: 13px;
        font-weight: 700;
        color: #334155;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    .rules-grid {
        display: grid;
        grid-template-columns: 2fr 1fr 1fr 1fr;
        gap: 12px;
    }

    .rule-box {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .rule-box label {
        font-size: 12px;
        font-weight: 600;
        color: #475569;
    }

    .clean-select,
    .clean-input {
        height: 38px;
        padding: 0 12px;
        border-radius: 8px;
        background: #F8FAFC;
        border: 1px solid #CBD5E1;
        color: #0F172A;
        font-size: 13px;
        font-weight: 600;
        outline: none;
        transition: all 0.15s;
    }

    .clean-select:focus,
    .clean-input:focus {
        background: #FFFFFF;
        border-color: #FF6A00;
        box-shadow: 0 0 0 3px rgba(255, 106, 0, 0.12);
    }

    /* OPÇÕES */
    .options-card {
        background: #FFFFFF;
        border: 1px solid #E2E8F0;
        border-radius: 12px;
        padding: 18px 20px;
        display: flex;
        flex-direction: column;
        gap: 14px;
        box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
    }

    .options-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .options-title {
        display: block;
        font-size: 14px;
        font-weight: 700;
        color: #0F172A;
    }

    .options-subtitle {
        font-size: 12px;
        color: #64748B;
    }

    .btn-add-option {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        height: 34px;
        padding: 0 14px;
        background: #F1F5F9;
        border: 1px solid #CBD5E1;
        border-radius: 8px;
        font-size: 12px;
        font-weight: 700;
        color: #0F172A;
        cursor: pointer;
        transition: all 0.15s ease;
    }

    .btn-add-option:hover {
        background: #FFFFFF;
        border-color: #0F172A;
    }

    .options-list {
        display: flex;
        flex-direction: column;
        gap: 8px;
        max-height: 380px;
        overflow-y: auto;
        padding-right: 6px;
        padding-bottom: 4px;
        scrollbar-width: thin;
        scrollbar-color: #CBD5E1 transparent;
    }

    .options-list::-webkit-scrollbar {
        width: 6px;
    }

    .options-list::-webkit-scrollbar-track {
        background: #F1F5F9;
        border-radius: 6px;
    }

    .options-list::-webkit-scrollbar-thumb {
        background: #CBD5E1;
        border-radius: 6px;
    }

    .options-list::-webkit-scrollbar-thumb:hover {
        background: #94A3B8;
    }

    .empty-options {
        padding: 24px;
        text-align: center;
        color: #94A3B8;
        font-size: 13px;
        background: #F8FAFC;
        border-radius: 8px;
        border: 1px dashed #CBD5E1;
    }

    .option-row {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 8px 12px;
        background: #F8FAFC;
        border: 1px solid #E2E8F0;
        border-radius: 8px;
        transition: all 0.15s ease;
    }

    .option-row:hover {
        border-color: #CBD5E1;
        background: #FFFFFF;
    }

    .option-row.is-disabled {
        opacity: 0.5;
    }

    .col-status {
        display: flex;
        align-items: center;
        flex-shrink: 0;
    }

    .option-check {
        width: 16px;
        height: 16px;
        cursor: pointer;
        accent-color: #FF6A00;
    }

    .col-name {
        flex: 1;
    }

    .option-name-input {
        width: 100%;
        height: 36px;
        padding: 0 10px;
        background: #FFFFFF;
        border: 1px solid #CBD5E1;
        border-radius: 6px;
        font-size: 13px;
        font-weight: 600;
        color: #0F172A;
        outline: none;
    }

    .option-name-input:focus {
        border-color: #FF6A00;
    }

    .col-price {
        display: flex;
        align-items: center;
        width: 120px;
        flex-shrink: 0;
        position: relative;
    }

    .currency-prefix {
        position: absolute;
        left: 8px;
        font-size: 12px;
        font-weight: 600;
        color: #64748B;
        pointer-events: none;
    }

    .option-price-input {
        width: 100%;
        height: 36px;
        padding: 0 8px 0 28px;
        background: #FFFFFF;
        border: 1px solid #CBD5E1;
        border-radius: 6px;
        font-size: 13px;
        font-weight: 600;
        color: #0F172A;
        outline: none;
        text-align: right;
    }

    .option-price-input:focus {
        border-color: #FF6A00;
    }

    .col-actions {
        flex-shrink: 0;
    }

    .btn-remove-option {
        width: 32px;
        height: 32px;
        border-radius: 6px;
        background: transparent;
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: background 0.15s;
    }

    .btn-remove-option:hover {
        background: #FEE2E2;
    }

    .btn-remove-option:hover :global(svg) {
        stroke: #DC2626 !important;
    }

    /* FOOTER */
    .editor-footer {
        display: flex;
        justify-content: flex-end;
        padding-top: 14px;
        padding-bottom: 4px;
        border-top: 1px solid #E2E8F0;
        position: sticky;
        bottom: 0;
        background: #F8FAFC;
        z-index: 10;
    }

    .btn-save-group {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        height: 44px;
        padding: 0 22px;
        background: #FF6A00;
        color: #FFFFFF;
        font-size: 14px;
        font-weight: 700;
        border-radius: 10px;
        border: none;
        cursor: pointer;
        transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 2px 6px rgba(255, 106, 0, 0.25);
    }

    .btn-save-group:hover {
        background: #EA580C;
        box-shadow: 0 4px 12px rgba(255, 106, 0, 0.35);
        transform: translateY(-1px);
    }

    @media (max-width: 640px) {
        .rules-grid {
            grid-template-columns: 1fr 1fr;
        }

        .col-price {
            width: 90px;
        }

        .btn-save-group {
            width: 100%;
            justify-content: center;
        }
    }
</style>
